import { render, staticRenderFns } from "./ProviderPchOrders.vue?vue&type=template&id=a7a0aa92&lang=pug&"
import script from "./ProviderPchOrders.vue?vue&type=script&lang=js&"
export * from "./ProviderPchOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPchOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderPchOrders.vue"
export default component.exports